import React, { useContext, useEffect, useState } from 'react'
import { Card, CardBody, IconButton, Checkbox, Spinner } from "@material-tailwind/react";
import { Pagination, SearchAndAddBtn, Dropdowns, THead } from '../../Components';
import { get_Rating, get_Rating_DropDownList } from '../../Controller/actions';
import { NewContext } from '../../Context/NewContext';
import { RiDeleteBinLine } from 'react-icons/ri';
import { IoEyeOutline } from 'react-icons/io5';
import RatingModel from '../../Components/Modals/RatingModel';
import FeedbackModel from '../../Components/Modals/FeedbackModel';
import { FaStar } from 'react-icons/fa';
import { TbLayout2, TbUser } from 'react-icons/tb';
import { AiOutlineAndroid } from 'react-icons/ai';
import { DatePicker, Space } from 'antd';
import moment from 'moment';
const { RangePicker } = DatePicker;


export const Rating = ({ title }) => {
    const { permissions, tokenType, setDeleteUpdateTag, setDeleteUpdateItem, setAddEditDeleteTag, setFormData, confirmationModalShow, setConfirmationModalShow, capitalalizeFirstletter, isLoading, deleteUpdateTag, checkedValues, handleCheckboxChange, currentPage, totalPage, perPage, search, setDeleteUpdateYes, setIsLoading, setCurrentPage, setPerPage, setTotalPage, currentPageData, setCurrentPageData, filterDropdown, handleOpen, isAscending, sortData, selectedDates } = useContext(NewContext);
    const simpleFields = [
        { name: "App Name", sortable: true, field: 'appName' },
        { name: "App Version", sortable: true, field: 'appVersion' },
        { name: "Date", sortable: true, field: 'createdAt' },
        { name: "Review", sortable: true, field: 'review' },
        { name: "Rating", sortable: true, field: 'rating' },
    ];
    const [pagePermissions, setPagePermissions] = useState({
        CU: true,
        R: true,
        D: true
    });
    const dropdownFields = [{}];
    const totalFields = simpleFields.length + dropdownFields.length + 2;
    const [appNamelist, setAppNamelist] = useState([]);
    const [version, setVersion] = useState([]);
    const [date, setDate] = useState([]);


    const DropDownList = async () => {
        const DropDownData = await get_Rating_DropDownList();
        DropDownData?.data?.appName?.map(_ele => setAppNamelist(_prev => !appNamelist.includes(_prev) && [..._prev, { id: _ele?._id, label: capitalalizeFirstletter(_ele) }]))
        DropDownData?.data?.appVersion?.map(_ele => setVersion(_prev => !version.includes(_prev) && [..._prev, { id: _ele?._id, label: capitalalizeFirstletter(_ele) }]))
    }
    useEffect(() => {
        DropDownList();
    }, [])

    const FilterDropdowns = ({ appNamelist, version, date }) => {
        return (
            <div className='flex gap-2.5'>
                <Dropdowns title={`Application`} name={`appName`} Icon={TbLayout2} dropData={appNamelist} />
                <Dropdowns title={`Version`} name={`version`} Icon={AiOutlineAndroid} dropData={version} />
                {/* <Dropdowns title={`Date`} name={`date`} Icon={MdOutlineTimer} dropData={date} /> */}
            </div>

        )
    }

    const getRatingData = async (_currentPage = 1, sortName = sortData, sortType = isAscending, startDate, endDate) => {
        setIsLoading(true);
        try {
            const getRating = await get_Rating(_currentPage, perPage, search, filterDropdown, sortName, sortType, startDate, endDate);
            if (getRating) {
                const { status, data, currentPage, perPage, totalPage } = getRating;
                if (status) {
                    setCurrentPageData(data);
                    setCurrentPage(currentPage);
                    setPerPage(perPage);
                    setTotalPage(totalPage || 1);
                } else {
                    setCurrentPageData([]);
                }
            }
        } catch (error) {
            console.error(error);
        }
        setIsLoading(false);
    }

    useEffect(() => {
        if (tokenType === 'ldap') {
            const update = permissions?.subPermissions?.find((route) => route.name === 'Rating_message');
            setPagePermissions({ ...pagePermissions, CU: update?.CU, R: update?.R, D: update?.D })
        }
    }, [tokenType, permissions])

    useEffect(() => {
        const [startDate, endDate] = selectedDates;
        getRatingData(currentPage, sortData, isAscending, startDate, endDate);
        setDeleteUpdateTag("");
    }, [deleteUpdateTag, search, currentPage, perPage, filterDropdown, pagePermissions, sortData, isAscending, selectedDates]);


    useEffect(() => {
        document.title = title;
    }, [title])

    return (
        <>
            <SearchAndAddBtn title={`Rating`} addBtn={false} excelBtn={true} datePicker={true} FilterDropdowns={<FilterDropdowns appNamelist={appNamelist} version={version} date={date} />} deleteUpdateTag='all-delete-rating' />
            <Card className="overflow-hidden w-full rounded-md shadow-none">
                <CardBody className="overflow-x-auto w-100 py-2.5 px-[5px] card-body-scrollbar">
                    <table className="w-full min-w-max table-auto text-left ">
                        <THead simpleFields={simpleFields} />
                        <tbody>
                            {
                                isLoading ?
                                    <tr>
                                        <td colSpan={totalFields} className='py-12'>
                                            <div className="flex justify-center items-center">
                                                <Spinner />
                                            </div>
                                        </td>
                                    </tr>
                                    : currentPageData?.length === 0 ?
                                        <tr>
                                            <td colSpan={totalFields} className='py-12 bg-gray-200'>
                                                <div className="flex justify-center items-center">
                                                    No Data Found
                                                </div>
                                            </td>
                                        </tr>
                                        : currentPageData?.map((_ele, i) => {
                                            const isLast = i === currentPageData?.length - 1;
                                            const classes = `text-[#1E1627] ${isLast ? "p-4" : "p-[14.5px]"}`;

                                            return (
                                                <tr key={i} className='border-b border-blue-gray-50'>
                                                    <td className={classes}>
                                                        <Checkbox
                                                            className='w-[18px] h-[18px] border-[1.5px] rounded-[3.6px] border-[#1E3354] checked:bg-[#0047FF] checked:border-transparent'
                                                            id={`slider-${_ele._id}`}
                                                            value={`${_ele._id}`}
                                                            disabled={!pagePermissions?.CU}
                                                            checked={checkedValues.includes(`${_ele._id}`)}
                                                            onChange={() => handleCheckboxChange(`${_ele._id}`)}
                                                        />
                                                    </td>

                                                    <td className={classes}>
                                                        <div className="flex items-center">
                                                            <span className={`font-normal text-[17px] ${!_ele?.appName && !_ele?.userId?.appName && `text-gray-500`}`}>{_ele?.appName ? _ele?.appName : _ele?.userId?.appName ? _ele?.userId?.appName : `None`}</span>
                                                        </div>
                                                    </td>
                                                    <td className={classes}>
                                                        <div className="flex items-center">
                                                            <span className={`font-normal text-[17px] ${!_ele?.appVersion && !_ele?.userId?.appVersion && `text-gray-500`}`}>{_ele?.appVersion ? _ele?.appVersion : _ele?.userId?.appVersion ? _ele?.userId?.appVersion : `None`}</span>
                                                        </div>
                                                    </td>
                                                    <td className={classes}>
                                                        <div className="flex items-center">
                                                            <span className={`font-normal text-[17px] ${(!_ele?.createdAt && !_ele?.userId?.createdAt) ? 'text-gray-500' : ''}`}>
                                                                {
                                                                    _ele?.createdAt ?
                                                                        moment(_ele?.createdAt).format('DD/MM/YYYY, hh:mm A') :
                                                                        (_ele?.userId?.createdAt ? moment(_ele?.userId?.createdAt).format('DD/MM/YYYY, hh:mm A') : 'None')
                                                                }
                                                            </span>
                                                        </div>
                                                    </td>
                                                    <td className={classes}>
                                                        <div className="items-center !w-52 block truncate">
                                                            <span className={`font-normal text-[17px] ${!_ele.review && `text-gray-500`}`}>{_ele.review || `None`}</span>
                                                        </div>
                                                    </td>
                                                    <td className={classes}>
                                                        <div className="flex items-center gap-1">
                                                            <FaStar />{" "}<span className={`font-normal text-[17px] ${!_ele.rating && `text-gray-500`}`}>{Math.round(Number(_ele.rating)).toFixed(1) || `None`}</span>
                                                        </div>
                                                    </td>
                                                    <td className={classes}>
                                                        <div className="flex items-center gap-2">
                                                            {/* <IconButton className='bg-[#EAEDF3] text-[#0047FF] text-[21px] shadow-none hover:shadow-none' onClick={() => { setDeleteUpdateYes("update-rating"); setAddEditDeleteTag(`update`); setFormData(_ele); handleOpen() }}>
                                                                <BiEdit />
                                                            </IconButton> */}
                                                            <IconButton className='bg-[#EAEDF3] text-[#0047FF] text-[21px] shadow-none hover:shadow-none' disabled={!pagePermissions?.CU} onClick={() => { setAddEditDeleteTag(`view`); setFormData(_ele); handleOpen() }}>
                                                                <IoEyeOutline />
                                                            </IconButton>
                                                            <IconButton className='bg-[#EAEDF3] text-[#F62929] text-[21px] shadow-none hover:shadow-none' disabled={!pagePermissions?.D} onClick={() => { setDeleteUpdateYes("delete-rating"); setDeleteUpdateItem({ id: _ele._id, name: _ele.name }); setConfirmationModalShow(!confirmationModalShow) }}>
                                                                <RiDeleteBinLine />
                                                            </IconButton>
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })
                            }
                        </tbody>
                    </table>
                </CardBody>
            </Card>
            {
                totalPage > 1 &&
                <Pagination currentPage={currentPage} totalPage={totalPage} getData={getRatingData} />
            }
            {/* <RatingModel /> */}
            <FeedbackModel ratingMode={true} />
        </>
    )
}
Rating.defaultProps = {
    title: "Message | Rating"
};



export default Rating
